module.exports = __webpack_public_path__ + "static/media/undraw-to-do-list.4a743399.svg";